const { __ } = wp.i18n

const body = document.body
const object = vnObject

import { Modal } from 'bootstrap'

const setThemeVars = () => {
  const test = __('Test JS translation', 'vn')
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('.footer__container ')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('header')
  if (headerContainer) {
    const headerContainerHeight = headerContainer.clientHeight
    body.style.setProperty('--header-height', `${headerContainerHeight}px`)
  }

  body.style.setProperty(
      '--space-width',
      `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

/*const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
  ;[...allModals].map((modal) => {
    new Modal(modal)
  })
}*/

document.addEventListener('DOMContentLoaded', function(dom) {
  const tel = dom.target.querySelectorAll('[href^="tel:"]')
  if (tel.length && object.gtmPhoneClass !== '') {
    tel.forEach((el) => {
      el.classList.add(object.gtmPhoneClass)
    })
  }
  const maps = dom.target.querySelectorAll('[href*="maps"]')

  if (maps.length && object.gtmItineraryClass !== '') {
    maps.forEach((el) => {
      el.classList.add(object.gtmItineraryClass)
    })
  }
  const mails = dom.target.querySelectorAll('[href^="mailto:"]')

  if (mails.length && object.gtmMailClass !== '') {
    mails.forEach((el) => {
      el.classList.add(object.gtmMailClass)
    })
  }

  const cookies = dom.target
    .querySelector('footer li.cookies')

  if (cookies) {
    cookies.addEventListener('click', function(e) {
      e.preventDefault()
      openAxeptioCookies()
    })
  }

  const dataHrefs = dom.target.querySelectorAll('[data-href]')
  if (dataHrefs.length) {
    dataHrefs.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        window.location.href = el.dataset.href
      })
    })
  }
})
